
(function () {
  'use strict';
  angular.module('finance.vckkcat')
    .component('kkcateditor', {
      restrict: 'E',
      bindings: {
        kkcat: '<?',
        kkcatid: '<?'
      },
      template: `
        <kkcatform kkcat="vm.kkcat" parentsave="vm.childsave(kkcat)" oncancel="vm.oncancel()">
        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> kkcat erfolgreich gespeichert!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen kkcat wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> kkcat konnte nicht gespeichert werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Kkcat', 'Rlog',
        function ($log, Kkcat, Rlog) {
          let vm = this;
          vm.save = save;
          vm.childsave = childsave;
          vm.oncancel = oncancel;
          
          vm.$onInit = function () {
            if ((angular.isUndefined(vm.kkcat) || !vm.kkcat.hasOwnProperty('_id'))
              && angular.isDefined(vm.kkcatid)) {
              getKKcat();
            }
          };

          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.kkcatid) && angular.isDefined(changes.kkcatid.currentValue) &&  changes.kkcatid.currentValue.length > 0) {
              vm.kkcatid = changes.kkcatid.currentValue;
              getKKcat();
            }
          }

          function getKKcat() {
            Kkcat.$find(vm.kkcatid).$then(function (kkcat) {
              vm.kkcat = kkcat;
            }, function (err) {
              $log.error('kkcat not found, id: ', vm.kkcatid);
              Rlog.error('kkcat', 'kkcateditor', 'kkcat not found', {_id: vm.kkcatid});
            });
          }


          function childsave(kkcat) {
            // vm.kkcat = angular.copy(kkcat);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in kkcat) {
              if (kkcat.hasOwnProperty(key)) {
                vm.kkcat[key] = kkcat[key];
              }
            }
            vm.save();
          }
          
          function save() {
            if (vm.kkcat.$hasPendingActions()) {
              vm.kkcat.$cancel();
              vm.kkcat.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of kkcat failed: ', err);
                Rlog.error('vcutils.kkcat', 'kkcateditor', 'Saving of kkcat failed: ', {error: err, kkcatid: vm.kkcat._id});
              });
            }
            else {
              vm.kkcat.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of kkcat failed: ', err);
                Rlog.error('vcutils.kkcat', 'kkcateditor', 'Saving of kkcat failed: ', {error: err, kkcatid: vm.kkcat._id});
              });
            }
          }
          
          function oncancel() {
            vm.canceled = true;
          }
          
          
        }] // controller
    }); // component

// klammerfriedhof
}());